import Card from '../../gs-component-card';
import { H4 } from '@xo-union/tk-ui-typography';
import { take } from 'lodash';
import React, { useContext, useState } from 'react';

import { Room, TransientRoomsContext } from '../contexts/TransientRooms';
import styles from './hotelPlannerCard.scss';
import HotelPlannerLogo from './HotelPlannerLogo';
import Row from './Row';
import TransientRoomComponent from './TransientRoomComponent';
import ViewMoreButton from './ViewMoreButton';

interface Props {
  onClick: (room: Room) => void;
}

const cardsToShow = 3;

const HotelPlannerCard: React.FC<Props> = ({ onClick }) => {
  const rooms = useContext<Room[]>(TransientRoomsContext);
  const [showing, setShowing] = useState(cardsToShow);
  if (rooms.length === 0) {
    return null;
  }

  return (
    <Card>
      <div className={styles.container}>
        <Row>
          <H4>Recommended Hotels Near Your Venue</H4>
        </Row>
        {take(rooms, showing).map((room: Room) => (
          <Row key={`transientRoom${room.propertyId}`}>
            <TransientRoomComponent room={room} onClick={onClick} />
          </Row>
        ))}
        <Row className={styles.poweredBy}>
          <HotelPlannerLogo />
        </Row>
        <ViewMoreButton rooms={rooms} showing={showing} onClick={(): void => setShowing(v => v + cardsToShow)} />
      </div>
    </Card>
  );
};

export default HotelPlannerCard;
